import { createReducer } from '@reduxjs/toolkit';
import { PortofolioDetailListInterface } from 'app/interfaces/lender/PortofolioDetailInterface';
import { ICommonState } from '../../interfaces/reducer-interface/common.interface';
import {
	downloadFactsheetAction,
	getLenderSummaryHeaderAction,
	getPortofolioDetailAction,
	getPortofolioListAction,
	resetFactsheetAction,
	setFactsheetAction,
	setLenderSummaryAction,
	setPortofolioDetailAction,
	setPortofolioListAction,
} from '../actions/PortofolioAction';

export interface ILenderSummaryHeader {
	lenderId: string;
	cashBalance: number;
	outStandingBalance: number;
	estTotalGet: number;
	estInterestGet: number;
	additionalCashBalance: number;
}
export interface IPortofolioListItem {
	loanType: string;
	borrowerName: string;
	transactionNumber: string;
	loanNumber: string;
	totalLoan: number;
	disbursementDate: number;
	dueDate: number;
	tenor: number;
	tenorPeriod: number,
	tenorValue: string,
	statusId: number;
	statusName: string;
	loanSecureId: string;
	docTokenUrl: string;
	lenderAgreementFile: string;
	lenderAgreementUrl: string;
	propertyLenderId: string;
	factsheetUrl: string;
	isSigned: boolean;
	lastPage: number;
	xignaturePpUrl: string;
	xignaturePpfpUrl: string;
	dgsignType: string;
}

export interface IPortofolioListDetail {
	detailList: PortofolioDetailListInterface[];
	propertyLenderId: string;
	pagination: IPagination;
}

export interface IPagination {
	totalData: number;
	totalPage: number;
	page: number;
}

export interface IPortofolioListState extends ICommonState {
	lenderSummary: ILenderSummaryHeader;
	portofolioList: IPortofolioListItem[];
	portofolioDetail: IPortofolioListDetail;
	pagination: IPagination;
	summaryLoading: boolean;
	factsheetBase64: Blob | undefined;
}

const lenderSummaryInit: ILenderSummaryHeader = {
	lenderId: '',
	cashBalance: 0,
	outStandingBalance: 0,
	estTotalGet: 0,
	estInterestGet: 0,
	additionalCashBalance: 0
};

const paginationInit: IPagination = {
	totalData: 0,
	totalPage: 0,
	page: 0,
};

export const portofolioDetailInit: IPortofolioListDetail = {
	detailList: [],
	propertyLenderId: '',
	pagination: paginationInit,
};

const initialState: IPortofolioListState = {
	summaryLoading: false,
	loading: false,
	lenderSummary: lenderSummaryInit,
	portofolioList: [],
	portofolioDetail: portofolioDetailInit,
	pagination: paginationInit,
	error: '',
	message: '',
	factsheetBase64: undefined,
};

const portofolioReducer = createReducer(initialState, (builder) => {
	builder
		.addCase(getLenderSummaryHeaderAction, (state) => ({
			...state,
			summaryLoading: true,
		}))
		.addCase(setLenderSummaryAction, (state, action) => ({
			...state,
			summaryLoading: false,
			lenderSummary: action.payload,
		}))
		.addCase(getPortofolioListAction, (state) => ({
			...state,
			loading: true,
		}))
		.addCase(setPortofolioListAction, (state, action) => ({
			...state,
			loading: false,
			portofolioList: action.payload.portofolioList,
			pagination: action.payload.pagination,
		}))
		.addCase(getPortofolioDetailAction, (state) => ({
			...state,
		}))
		.addCase(setPortofolioDetailAction, (state, action) => ({
			...state,
			portofolioDetail: action.payload,
		}))
		.addCase(downloadFactsheetAction, (state) => ({
			...state
		}))
		.addCase(setFactsheetAction, (state, action) => ({
			...state,
			factsheetBase64: action.payload.base64Image
		}))
		.addCase(resetFactsheetAction, (state) => ({
			...state,
			factsheetBase64: undefined
		}))
		.addDefaultCase((state) => state);
});

export default portofolioReducer;
